import { render, staticRenderFns } from "./AdditionalFactorsSection.vue?vue&type=template&id=511ec90e"
import script from "./AdditionalFactorsSection.vue?vue&type=script&lang=js"
export * from "./AdditionalFactorsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports